import $ from 'jquery';

const HideAddToCart = () => {
    const init = () => {
        hide_button();
    } 

    const hide_button = () => {
        if ($('#js-loggedout').length < 1) return;
        const value = $('#js-loggedout').val();
        const link = '/login' || $('#js-loggedout').attr('link')  ; 
        const htmlClasses = $('html').attr('lang');
        const currentLanguage = htmlClasses ? htmlClasses.split('-')[0] : 'nl';
        const homeURL = window.location.origin + '/' + currentLanguage;
        const languageLink = homeURL + link;
        const el = '<a class="js-loggedout" href="' + languageLink + '">' + value + '</a>';
        $('.single_variation_wrap').html(el);
    }

    init();
}

try {
    HideAddToCart();
} catch (error) {
    console.error('Hide Add To Cart', error);
}